export default function(obj, name) {
  obj[name] = {
    TRACK: `${name}_TRACK`,
  };
}
